import { css } from '@emotion/react';
import type { ScheduleDefinitionCalendarEvent } from '../../../types';

interface Props {
  event: ScheduleDefinitionCalendarEvent;
}
export const ScheduleDefinitionEvent = ({ event }: Props) => {
  return <div css={containerStyle}>{event.eventType}</div>;
};

const containerStyle = css({
  borderRadius: 4,
  // TODO: Use theme tokens for these styles
  background: 'linear-gradient(0deg, #fff9e2, #fff9e2)',
  borderLeft: '4px solid #F2BE04',
  color: '#14532d',
});
